import { Application, AstroStorage, BasePlugin, Device, StorageType } from '@goodboydigital/astro';

import { App } from '../App';

export class StoragePlugin extends AstroStorage implements BasePlugin
{
    public app: App;

    constructor(app: Application)
    {
        super(StorageType.LOCAL, 'com.turner.toontrails');
        this.app = app as App;
    }

    public update(): void
    {
        //
    }
    
    getObject(key: string) {
        return JSON.parse(this.getItem(key) || "{}");
    }
}
